import router from '../router'

export const handleParams = (path, id) => {
  const currentId = router.currentRoute.query.id
  currentId !== id && router.push({ path, query: { id } })
}
